import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface LongTextFieldModel extends BaseFieldModel {
  defaultValue: CultureTextModel[] | string;
  placeholder: CultureTextModel[] | string;
  minLength: number | undefined;
  maxLength: number | undefined;
  type: FieldType.LongText;
}

export class LongTextField extends BaseField implements LongTextFieldModel {
  public defaultValue: CultureTextModel[] | string = '';
  public placeholder: CultureTextModel[] | string = '';
  public minLength: number | undefined;
  public maxLength: number | undefined;
  public type: FieldType.LongText = FieldType.LongText;

  constructor(cultures: string[]) {
    super(FieldType.LongText, cultures);
    this.minLength = 0;
    this.maxLength = 50;

    this.placeholder = [];
    this.defaultValue = [];

    for (const culture of cultures) {
      this.placeholder.push({ culture, value: '' });
      this.defaultValue.push({ culture, value: '' });
    }
  }
}
